export default "__VITE_ASSET__d5d30406__"